import { nextTick } from 'vue'
import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
    async scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: "instant",
            }
        }
        await nextTick()
        // On refresh or standard navigation, always go to top
        return { top: 0, left: 0 }
    }
}